function isValidHttpUrl(string) {
    const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

    return !!pattern.test(string);
}

function containsEmailOrPhoneNumber(string) {
    const emailMatches = string.match(/[a-zA-Z0-9.!#$%&\'*+\/=?^_`{|}~-]+(@|\s*\(*\s*at\s*\)*\s*)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+/mgi);

    if (null !== emailMatches) {
        return true;
    }

    const phoneMatches = string.match(/[\d\+\-][\s\d\.\-\+\(\)\\\/]{7,}[\d]/mgi);

    return null !== phoneMatches;
}

function containsWebsite(string) {
    const websiteMatches = string.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi);

    const websiteMatchesWithoutHttp = string.match(/[a-zA-Z0-9]+\.[+[fr|be|com]{2,}/gi);

    return null !== websiteMatches || null !== websiteMatchesWithoutHttp;
}

export function editProfile(field, callback) {
    let value;

    if ('description' === field) {
        value = $('#description-textarea').val();

        if (value.length < 200) {
            addAlert('danger', translations['profile.Min length error']);

            return;
        }

        if (value.length > 4000) {
            addAlert('danger', translations['profile.Max length error']);

            return;
        }
    } else if ('punchline' === field) {
        value = $('#punchline-textarea').val();

        if (value && (value.length < 100)) {
            addAlert('danger', translations['profile.Punchline min length error']);

            return;
        }

        if (value && (value.length > 230)) {
            addAlert('danger', translations['profile.Punchline max length error']);

            return;
        }

        if (value && containsEmailOrPhoneNumber(value)) {
            addAlert('danger', translations['profile.Punchline contains email or phone number']);

            return;
        }
    } else if ('diplomas' === field) {
        value = $('#diplomas-textarea').val();

        // if (value && (value.length < 200)) {
        //     addAlert('danger', translations['profile.Min length error']);
        //
        //     return;
        // }

        if (value && (value.length > 4000)) {
            addAlert('danger', translations['profile.Max length error']);

            return;
        }

        // if (value && containsEmailOrPhoneNumber(value) || value && containsWebsite(value)) {
        //     $('#contact-details-found-modal').modal('show');
        //
        //     return;
        // }
    } else if ('payment_check' === field) {
        value = $('#payments-check-switch').prop('checked');
    } else if ('payment_bank_transfer' === field) {
        value = $('#payments-bank-transfer-switch').prop('checked');
    } else if ('payment_cash' === field) {
        value = $('#payments-cash-switch').prop('checked');
    } else if ('payment_card' === field) {
        value = $('#payments-credit-card-switch').prop('checked');
    } else if ('payment_installments' === field) {
        value = $('#payment-installments-switch').prop('checked');
    } else if ('legal_aid' === field) {
        value = $('#legal-aid-switch').prop('checked');
    } else if ('online_consultation' === field) {
        value = $('#online-consultation-switch').prop('checked');
    } else if ('hourly_rate' === field) {
        value = {
            from: $('#hourly-rate-from-input').val(),
            to: $('#hourly-rate-to-input').val(),
        };

        if (!Number(value.from) || !Number(value.to) || Number(value.from) > Number(value.to)) {
            addAlert('danger', translations['profile.Invalid hourly rates.']);

            return;
        }

        value = JSON.stringify(value);
    } else if ('languages' === field) {
        value = $('#languages-input').val().join(',');
    } else if ('specialism' === field) {
        value = $('#specialism-input').val().join(',');

        if (!value) {
            addAlert('danger', translations['profile.Please choose at least one specialism.']);

            return;
        }
    } else if ('taux_horaire' === field) {
        value = $('#pricing-type-taux_horaire').prop('checked');
    } else if ('forfait' === field) {
        value = $('#pricing-type-forfait').prop('checked');
    } else if ('abonnement' === field) {
        value = $('#pricing-type-abonnement').prop('checked');
    } else if ('selon_convention_dhonoraires' === field) {
        value = $('#pricing-type-selon_convention_dhonoraires').prop('checked');
    } else if ('au_resultat' === field) {
        value = $('#pricing-type-au_resultat').prop('checked');
    } else if ('barreau' === field) {
        value = $('#barreau-input').val();
    } else if ('notifications_center_messages_email' === field) {
        value = $('#notifications_center_messages_email').prop('checked');
    } else if ('notifications_center_messages_sms' === field) {
        value = $('#notifications_center_messages_sms').prop('checked');

        if (value && !$('#notification-phone-input').val()) {
            addAlert('danger', translations['account.notifications_center.Missing SMS notification number']);

            $('#notifications_center_messages_sms').prop('checked', !value);

            return;
        }
    } else if ('notifications_center_reminders_email' === field) {
        value = $('#notifications_center_reminders_email').prop('checked');
    } else if ('notifications_center_reminders_sms' === field) {
        value = $('#notifications_center_reminders_sms').prop('checked');

        if (value && !$('#notification-phone-input').val()) {
            addAlert('danger', translations['account.notifications_center.Missing SMS notification number']);

            $('#notifications_center_reminders_sms').prop('checked', !value);

            return;
        }
    } else if ('notifications_center_product_changes_email' === field) {
        value = $('#notifications_center_product_changes_email').prop('checked');
    } else if ('notifications_center_product_changes_sms' === field) {
        value = $('#notifications_center_product_changes_sms').prop('checked');

        if (value && !$('#notification-phone-input').val()) {
            addAlert('danger', translations['account.notifications_center.Missing SMS notification number']);

            $('#notifications_center_product_changes_sms').prop('checked', !value);

            return;
        }
    } else if ('notification_phone' === field) {
        value = $('#notification-phone-input').val();

        let isValidPhoneNumber = false;

        if (value) {
            $.ajaxSetup({ async: false });

            $.get(routes['app_profile_isvalidphonenumber'], { phone_number: value }, function(result) {
                if (result.status) {
                    isValidPhoneNumber = result.is_valid_phone_number;
                }
            }).fail(function() {
            });

            $.ajaxSetup({ async: true });
        }

        if (!isValidPhoneNumber) {
            addAlert('danger', translations['profile.Invalid phone number.']);

            return;
        }
    } else if ('recruitment' === field) {
        value = $('#recruitment').prop('checked');

        if (field === 'recruitment') {
            dataLayer.push({
                event: 'dataLayer.gaEvent',
                gaEvent: {
                    'category': 'Account',
                    'action': `profile_recruitment_${value ? 'on' : 'off'}`,
                    'label': '',
                },
            });
        }
    } else {
        console.log('Invalid field.');

        return;
    }

    const data = {
        field: field,
        value: value,
    };

    showPreloader();

    $.post(routes['app_profile_edit'], data, function(result) {
        if (result.status) {
            if (field !== 'recruitment') {
                dataLayer.push({
                    event: 'dataLayer.gaEvent',
                    gaEvent: {
                        'category': 'Account',
                        'action': field + ' | Success',
                        'label': GA_EVENT_LABEL,
                    },
                });
            }

            addAlert('success', translations['profile.Changes saved!']);

            if ('description' === field) {
                $('#description-textarea-readonly').summernote('code',
                    $('#description-textarea').val(),
                );
            } else if ('punchline' === field) {
                $('#punchline-textarea-readonly').summernote('code',
                    $('#punchline-textarea').val(),
                );
            } else if ('diplomas' === field) {
                $('#diplomas-textarea-readonly').summernote('code',
                    $('#diplomas-textarea').val(),
                );
            } else if ('hourly_rate' === field) {
                $('#hourly-rate-from-readonly-input').val(
                    $('#hourly-rate-from-input').val(),
                );

                $('#hourly-rate-to-readonly-input').val(
                    $('#hourly-rate-to-input').val(),
                );
            } else if ('specialism' === field) {
                const values = $('#specialism-input').select2('data');

                $('#specialism-paragraph').find('span').remove();
                $('#specialism-paragraph').find('small').remove();

                $.each(values, function(index, value) {
                    $('#specialism-paragraph').append(
                        $('<span class="badge badge-lg bg-primary" data-term-id="' + value.id + '">' + value.text + '</span>'),
                    );

                    $('#specialism-paragraph').append(
                        $('<span>&nbsp;</span>'),
                    );
                });
            } else if ('working_hours' === field) {
                const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

                $.each(days, function(index, day) {
                    $('#open-' + day + '-readonly-switch').prop('checked',
                        $('#open-' + day + '-switch').prop('checked'),
                    );

                    $('#' + day + '-from-readonly-input').val(
                        $('#' + day + '-from-input').val(),
                    );

                    $('#' + day + '-to-readonly-input').val(
                        $('#' + day + '-to-input').val(),
                    );

                    if ($('#open-' + day + '-switch').prop('checked')) {
                        $('#' + day + '-from-readonly-input').closest('[class^="col-"]').show();
                        $('#' + day + '-to-readonly-input').closest('[class^="col-"]').show();
                    } else {
                        $('#' + day + '-from-readonly-input').closest('[class^="col-"]').hide();
                        $('#' + day + '-to-readonly-input').closest('[class^="col-"]').hide();
                    }
                });
            } else if ('barreau' === field) {
                const value = $('#barreau-input').select2('data')[0];

                $('#barreau-paragraph').find('span').remove();
                $('#barreau-paragraph').find('small').remove();

                $('#barreau-paragraph').append(
                    $('<span class="badge badge-lg bg-primary" data-term-id="' + value.id + '">' + value.text + '</span>'),
                );
            }

            if (callback) {
                callback();
            }
        } else {
            dataLayer.push({
                event: 'dataLayer.gaEvent',
                gaEvent: {
                    'category': 'Account',
                    'action': field + ' | Failure',
                    'label': GA_EVENT_LABEL,
                },
            });

            addAlert('danger', translations['profile.An unknown error occurred.']);
        }
    }).fail(function() {
        dataLayer.push({
            event: 'dataLayer.gaEvent',
            gaEvent: {
                'category': 'Account',
                'action': field + ' | Failure',
                'label': GA_EVENT_LABEL,
            },
        });

        addAlert('danger', translations['profile.An unknown error occurred.']);
    }).always(function() {
        hidePreloader();
    });

    refreshPriorityTab();
}

export async function editProfileSection(type) {
    let data;

    if ('contacts' === type) {
        let phone = $('#phone-input').val();
        let onlineConsultPhone = $('#online-consultation-phonenumb').val();

        let isValidPhoneNumber = false;
        let isOnlineConsultPhoneValid = false;

        if (phone) {
            showPreloader();

            try {
                const response = await fetch(routes['app_profile_isvalidphonenumber'] + '?' + new URLSearchParams({ phone_number: phone }), {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });

                const result = await response.json();

                isValidPhoneNumber = result.is_valid_phone_number;
            } catch (error) {
                console.log(error);
            }

            hidePreloader();
        }

        if (onlineConsultPhone) {
            showPreloader();

            try {
                const response = await fetch(routes['app_profile_isvalidphonenumber'] + '?' + new URLSearchParams({ phone_number: onlineConsultPhone }), {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                });

                const result = await response.json();

                isOnlineConsultPhoneValid = result.is_valid_phone_number;
            } catch (error) {
                console.log(error);
            }

            hidePreloader();
        }

        if (!isValidPhoneNumber || (onlineConsultPhone && !isOnlineConsultPhoneValid)) {
            addAlert('danger', translations['profile.Invalid phone number.']);

            return;
        }


        let website = $('#website-input').val();

        if (website && !website.startsWith('http')) {
            website = 'https://' + website;

            $('#website-input').val(website);
        }

        if (website && !isValidHttpUrl(website)) {
            addAlert('danger', translations['profile.Invalid url.']);

            return;
        }

        data = {
            type: type,
            phone: phone,
            website: website,
            onlineConsultationPhoneNumber: onlineConsultPhone,
        };
    }  else {
        console.log('Invalid field.');

        return;
    }

    showPreloader();

    $.post(routes['app_profile_editsection'], data, function(result) {
        if (result.status) {
            dataLayer.push({
                event: 'dataLayer.gaEvent',
                gaEvent: {
                    'category': 'Account',
                    'action': type + ' | Success',
                    'label': GA_EVENT_LABEL,
                },
            });

            addAlert('success', translations['profile.Changes saved!']);
        } else {
            dataLayer.push({
                event: 'dataLayer.gaEvent',
                gaEvent: {
                    'category': 'Account',
                    'action': type + ' | Failure',
                    'label': GA_EVENT_LABEL,
                },
            });

            addAlert('danger', translations['profile.An unknown error occurred.']);
        }
    }).fail(function() {
        dataLayer.push({
            event: 'dataLayer.gaEvent',
            gaEvent: {
                'category': 'Account',
                'action': type + ' | Failure',
                'label': GA_EVENT_LABEL,
            },
        });

        addAlert('danger', translations['profile.An unknown error occurred.']);
    }).always(function() {
        const $cancelButton = $('[data-container="editable-section"][data-type="' + type + '"]').find('[data-bs-toggle="cancel"]');

        $cancelButton.trigger('click');

        hidePreloader();
    });

    refreshPriorityTab();
}
